/**
 * D.1 — Convenience hook: is the signed-in user a Repancy operator?
 *
 * Thin wrapper over `useRepancyRole()` for surfaces that only need
 * a yes/no answer (e.g., the vault export menu's operator-gated
 * "New SharePoint site" target).
 *
 * Returns `false` during Clerk hydration (loading state) to avoid
 * flashing operator-only UI for non-operators while the user object
 * resolves.
 *
 * For server-side authorization, use Convex's `requireOperator`
 * helper — never trust a client-side role claim for an actual write
 * decision.
 */

import { useRepancyRole } from './useRepancyRole';

export function useIsOperator(): boolean {
  const { role, isLoading } = useRepancyRole();
  if (isLoading) return false;
  return role === 'operator';
}
